import { render, staticRenderFns } from "./BackgroundVideo.html?vue&type=template&id=5c3554f8&scoped=true&lang=html&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "./BackgroundVideo.scss?vue&type=style&index=0&id=5c3554f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3554f8",
  null
  
)

export default component.exports